import { jsx as _jsx } from "react/jsx-runtime";
export default function PrerenderHeader({
  header,
  value
}) {
  return /*#__PURE__*/_jsx("meta", {
    name: "prerender-header",
    content: `${header}: ${value}`,
    "data-test-id": "prerender-header"
  });
}